export default {
  start: {
    action: 'Naar de systemen',
    info: 'In 3 stappen de gewenste Remeha warmtepompoplossing. De Remeha Warmtepompwijzer biedt een overzicht van alle warmtepomp oplossingen binnen het Remeha assortiment. Hiermee bieden we je de zekerheid om snel en makkelijk de juiste warmtepomp te selecteren, offreren en te installeren.<br /><br />Stap 1: Filter op hybride of all-electric, vermogensklasse, nieuwe CV-ketel of kies direct het juiste type uit de lijst.<br /><br />Stap 2: Met de configurator bekijk je de opstelling en kies je de accessoires per product.<br /><br />Stap 3: Bekijk het artikeloverzicht met prijzen, download of verstuur de offerte. Of download extra documentatie.<br /><br />Handig, snel en zeker!',
    remark: 'Je kunt op dit moment geen gebruik maken van de advies vragen in verband met het nieuwe productassortiment.',
    savingAction: 'Warmtewijzer',
    savingInfo: 'Deze warmtepompwijzer is ontwikkeld voor de installateur. Wil je je klant adviseren of ben je zelf een consument op zoek naar meer informatie over warmtepompen en wat je kunt besparen kijk dan hier.',
    installerAction: 'Zoek installateur',
    installerInfo: 'Of vind een installateur die je verder kan helpen',
    title: 'In 3 stappen de geschikte Remeha warmtepompoplossing.',
    consumerTitle: 'Ben je consument?',
  },
  contentArea: {
    what: {
      action: 'Ga naar remeha.nl',
      content: 'Beter zou je kunnen vragen: hoe werkt een warmtepomp? Een warmtepomp zet warmte van buiten om in warmte voor in huis. Dat kan zijn warmte uit de lucht, water of de bodem. In de warmtepomp zit een vloeistof die al bij zeer lage temperatuur (tot -20 graden) verdampt. De warmte van buiten zet deze vloeistof om in gas. Dit gebeurt in de verdamper. Een compressor perst deze damp samen waardoor de temperatuur van de damp stijgt. Deze hete damp gaat door een warmtewisselaar aan de andere kant van de warmtepomp en geeft daar zijn warmte af aan het koude water uit de cv-installatie. Door het afgeven van warmte en het verlagen van de druk wordt de damp weer vloeistof en kan het hele proces weer opnieuw beginnen. Meer weten over warmtepompen?',
      title: 'Wat is een warmtepomp?',
    },
    hybrid: {
      title: 'Is een (hybride) warmtepomp geschikt voor mijn huis?',
      content: 'Voor een warmtepomp is het belangrijk dat je huis goed geïsoleerd is en dat er lage temperatuur afgiftesystemen aanwezig zijn. Denk dan aan vloerverwarming of lage temperatuur radiatoren. Is dat niet het geval, kies dan bijvoorbeeld voor een hybride systeem. Een cv-ketel levert namelijk warmwater tot wel 85 graden en doet dit snel. Een warmtepomp haalt maximaal 55 graden en heeft een aanlooptijd nodig om op temperatuur te komen. Een warmtepomp wordt daarom altijd gecombineerd met een boiler of buffervat voor warm water. Bij sommige warmtepompen zoals de Eria Tower, is het boilervat zelfs ingebouwd en bij de Neptuna is het buffervat ingebouwd.{lineBreak}{lineBreak}Zonder goede isolatie is er teveel warmteverlies. Hiermee daalt niet alleen het rendement van de warmtepomp, maar krijg je ook je huis niet goed warm. Je ziet dan ook dat warmtepompen voornamelijk worden toegepast in nieuwbouw woningen waarin de prestaties van de warmtepomp optimaal zijn afgestemd op de isolatie, het volume en de ventilatie van de woning. Weten of je huis geschikt is? Vraag je installateur.',
      action: 'Doe de wooncheck',
    },
  },

  detail: {
    leaveConfirmation: 'Bent u zeker dat u de wijzer wil stopzetten? Alle aanpassingen zullen verloren gaan.',
    leaveTitle: 'Bevestiging',
    title: 'Warmtepompwijzer',
    moreInfo: 'Meer info',
    end: 'Beëindigen',
    next: 'Volgende',
  },
  result: {
    title: 'We kunnen volgend systeem aanraden:',
    titleBuffer: 'We kunnen volgend systeem aanraden met een boilervat van {liter} liter:',
    quote: 'Offerte aanvragen',
    buffer: 'Buffervat configureren',
  },
  questions: {
    outsideSpace: {
      question: 'Is er voldoende ruimte om een buitendeel van een warmtepomp te plaatsen? Afmeting&nbsp;ca.&nbsp;70x70x40&nbsp;cm&nbsp;(hxbxd)',
      info: 'Het buitendeel kan op twee manieren geplaatst worden: <br/><br/>1. Staand: je kunt het buitendeel plaatsen op de grond, een plat- of schuin dak.<br/>2. Hangend: het buitendeel kan ook aan de gevel, muur, etc worden opgehangen met een wandbeugel.<br/><br/>Let op het geluidsdrukniveau op de erfgrens volgens wetgeving per 01.01.2021 bij het plaatsen van het buitendeel.',
      answers: {
        yes: 'Ja',
        no: 'Nee',
        dunno: 'Nog niet bekend',
        dunnoInfo: 'Controleer na het afronden van de selectie of het buitendeel past in de huidige situatie. ',
      },
    },
    buildYear: {
      question: 'Wanneer is het huis gebouwd?',
      answers: {
        early: 'Voor 1995',
        recent: '1995 - 2009',
        new: 'Na 2009',
      },
    },
    isolation: {
      question: 'Hoe is het huis geïsoleerd?',
      answers: {
        roof: 'Dakisolatie',
        wall: '(Spouw-) Muurisolatie',
        floor: 'Vloerisolatie',
        window: 'HR++ glas',
        none: 'Geen isolatie',
      },
    },
    heatingType: {
      question: 'Hoe wordt de woning verwarmd?',
      answers: {
        radiators: 'Radiatoren',
        radiatorsAndFloor: 'Radiatoren + Lage temperatuur&shy;ver&shy;warming (zoals vloer&shy;verwarming)',
        floor: 'Lage temperatuur&shy;ver&shy;warming (zoals vloer&shy;verwarming)',
      },
    },
    extraSpaceForBoiler: {
      question: 'Heeft u bij uw installatie extra ruimte beschikbaar en een sterke vloer<br/>voor een boilervat (afmeting&nbsp;ca.&nbsp;100x100x150&nbsp;cm)?',
      answers: {
        yes: 'Ja',
        no: 'Nee',
      },
    },
    notSuited: {
      question: 'De situatie is helaas niet geschikt voor een warmtepomp. Op onze website <a href="https://www.remeha.nl" target="_blank">www.remeha.nl</a> kunt u meer informatie vinden over andere duurzame oplossingen (zoals <a href="https://www.remeha.nl/consumenten/productinformatie/duurzame-oplossingen/zonlichtsystemen" target="_blank">zonlichtsystemen</a>) die mogelijk wel geschikt zijn.',
    },
    maybeSuited: {
      question: 'De situatie is mogelijk geschikt voor een hybride warmtepomp, maar we raden aan om eerst aanvullende maatregelen te nemen. Neem contact op met een accountmanager van Remeha in uw regio of stuur een mailverzoek om contact op te nemen naar: <a href="mailto:salessupport@remeha.nl">salessupport@remeha.nl</a>',
    },
    hybridHeatPump: {
      question: 'De situatie is geschikt voor een <b>Hybride warmtepomp</b>, wilt u ook een bijbehorende CV aanschaffen?',
      answers: {
        yes: 'Ja',
        no: 'Nee',
      },
    },
    allElectricHeatpump: {
      question: 'De situatie is geschikt voor een <b>All-electric warmtepomp</b>, ga door met het selecteren van de juiste All-electric warmtepomp',
    },
    household: {
      question: 'Wat is de grootte van het huishouden?<br/>(rekeninghoudend met eventuele wijzigingen in de toekomst)',
      info: 'De tapwaterbehoefteberekening gaat uit van de (toekomstige) grootte van het huishouden. Ook kan het aantal slaapkamers +1 (inclusief de zolder) worden aangehouden. Het kan zijn dat er minder mensen wonen dan slaapkamers +1 (de kinderen zijn bijvoorbeeld het huis al uit). Om in de toekomst het huis te kunnen verkopen is het advies om uit te gaan van het aantal slaapkamers + 1 (voorbeeld 3 slaapkamers = 4 personen)',
      answers: {
        1: '1 persoon',
        2: '2 personen',
        3: '3 personen',
        4: '4 personen',
        5: '5 personen',
        6: '5+ personen',
      },
    },
    temperatureZones: {
      question: 'Wat is het aantal onafhankelijk door warmtepomp geregelde temperatuurzones?',
      info: 'Door meerdere temperatuurzones kunnen verschillende kamers onfhankelijk van elkaar met een andere temperatuur verwarmd worden.<br/><br/>Raadpleeg Remeha (<a href="mailto:salessupport@remeha.nl">salessupport@remeha.nl</a>) voor maatwerkadvies. Het aanvinken van meerdere zones betekent een duurdere installatie.',
      answers: {
        1: '1',
        2: '2',
        3: '3',
        dunno: 'Nog niet bekend',
        dunnoInfo: 'Standaard gaat selectietool uit van 1 kamerthermostaat voor het gehele huis.',
      },
    },
    cooling: {
      question: 'Indien mogelijk, dient de woning ook gekoeld te worden? <br/><br/>Let op: Het afgiftesysteem moet geschikt zijn om de koude over te kunnen dragen aan de omgeving. (Plaat)radiatoren zijn hiervoor NIET geschikt.',
      info: 'Onder koeling wordt verstaan het aanbieden van topkoeling hetgeen inhoudt dat de ruimtetemperatuur maximaal circa 3°C lager kan worden gemaakt dan de buitenluchttemperatuur, waardoor de ruimte aangenamer aanvoelt. Let wel: het laten koelen van een ruimte kost geld.<br/><br/>Het afgiftesysteem moet geschikt zijn om de koude over te kunnen dragen aan de omgeving. (Plaat)radiatoren zijn hiervoor NIET geschikt.',
      answers: {
        yes: 'Ja',
        no: 'Nee',
        dunno: 'Nog niet bekend',
        dunnoInfo: 'Standaard gaat selectietool uit van koeling',
      },
    },
    hotWaterNeed: {
      question: 'Wat is het warmwater behoefte? (hoeveel liter van 40°C per minuut)',
      answers: {
        6: 'Besparende douche/bad (6&nbsp;ltr&nbsp;/&nbsp;min) - CW3',
        13: 'Standaard douche/bad (13&nbsp;ltr&nbsp;/&nbsp;min) - CW4',
        17: 'Grote douche/bad en/of meerdere badkamers (17&nbsp;ltr&nbsp;/&nbsp;min) - CW5',
        20: 'Stortdouche/luxe bad en/of meerdere badkamers (20&nbsp;ltr&nbsp;/&nbsp;min) - CW6',
      },
    },
    flueGasConnection: {
      question: 'Wat is het type rookgasaansluiting?',
      answers: {
        excentric: 'Excentrisch',
        concentric: 'Concentrisch',
        dunno: 'Nog niet bekend',
        dunnoInfo: 'Standaard gaan wij uit van excentrisch. Controleer uw rookgasaansluiting alvorens te gaan bestellen.',
      },
    },
    roomVolume: {
      question: 'Wat is de woninginhoud (m³)?',
      info: 'Vermenigvuldig de vloeroppervlakte van elke verdieping met de hoogte. De standaardhoogte van een verdieping is bij veel woningen 2,5 meter. De inhoud van een verdieping onder een schuin dak is vaak (iets meer dan) de helft van de vloeroppervlakte maal het hoogste punt.<br/><br/>Afhankelijk van de leeftijd van de woning in combinatie met de toegepaste isolatie zal het programma een antwoord genereren tot 1.000 m3 inhoud.',
      answers: {
        input: 'm³',
        dunno: 'Berekenen obv oppervlakte',
      },
    },
    floorArea: {
      question: 'Wat is de totale oppervlakte van de woning?<br/><br/>Onder totale oppervlakte wordt verstaan begane grond + verdieping(en) + zolder.',
      answers: {
        input: 'm²',
      },
    },
    ceilingHeight: {
      question: 'Wat is de plafondhoogte?',
      answers: {
        low: 'Laag (<&nbsp;2,5m)',
        average: 'Gemiddeld (2,5&nbsp;-&nbsp;2,6m)',
        high: 'Hoog (>&nbsp;2,6m)',
      },
    },
    temperature: {
      question: 'Op welke binnentemperatuur (in&nbsp;°C) wenst u de woning te verwarmen? ',
      answers: {
        input: '°C',
      },
    },
    unitType: {
      question: 'Wat is het type van de woning?',
      answers: {
        free: 'Vrijstaand',
        twoInOne: '2-onder-1 kap of hoekwoning',
        row: 'Rijwoning',
        apartment: 'Appartement',
      },
    },
    criteriumType: {
      question: 'Welk criterium is het meest belangrijk voor de bewoner?',
      answers: {
        comfort: 'Comfort',
        comfortInfo: 'Bij Comfort wordt er rekening gehouden met extra wensen in warm tapwater gebruik voor bad en/of douche. Dit kan leiden tot een groter model warmtepomp, grotere cv-ketel dan wel een groter buffervat inhoud voor warm tapwater.',
        price: 'Prijs',
        priceInfo: 'Bij Hybride warmtepomp ligt dekkingsgraad van warmtepomp aan de ondergrens van het jaarlijkse inzet gebied 88 – 94%.<br/><br/>Bij All Electric warmtepomp ligt dekkingsgraad van warmtepomp aan de ondergrens van het jaarlijkse inzetgebied 95 – 100%<br/><br/>Er wordt gestreefd naar een optimum in prijs en CO2 reductie (forse reductie van aardgasverbruik)',
        value: 'Duurzaamheid',
        valueInfo: 'Selectie vindt plaats op lokale maximale CO2-reductie.<br/><br/>Bij de Hybride warmtepomp ligt de dekkingsgraad van de warmtepomp aan de bovengrens van het jaarlijkse inzetgebied 88 – 94%.<br/><br/>Bij de All Electric warmtepomp ligt de dekkingsgraad van de warmtepomp aan de bovengrens van het jaarlijkse inzetgebied 95 – 100%<br/><br/>De investering valt mogelijk hierdoor hoger uit dan wanneer op basis van de prijs wordt geselecteerd.',
      },
    },
    customization: {
      question: 'Wij adviseren maatwerk, neem contact op met Remeha via een accountmanager in uw regio of stuur een mailverzoek om een offerte op maat te maken: <a href="mailto:salessupport@remeha.nl">salessupport@remeha.nl</a>',
    },
    bathroom: {
      question: 'Hoe ziet de badkamer eruit?',
      answers: {
        douche: 'Alleen douche',
        doucheAndBath: 'Douche en bad',
        multiple: 'Meer dan 1 badkamer',
      },
    },
    bath: {
      question: 'Wat is het type bad?',
      answers: {
        small: 'Klein zitbad<br/>50&nbsp;–&nbsp;100 liter',
        normal: 'Normaal ligbad<br/>100&nbsp;-&nbsp;140 liter',
        large: 'Groot bad<br/>140&nbsp;–&nbsp;200 liter',
        extraLarge: 'Luxe bad<br/>200&nbsp;–&nbsp;250 liter',
      },
    },
    bathFills: {
      question: 'Wat is het maximaal aantal badvullingen per dag waarin moet worden voorzien?<br/><br/>Let op: meer badvullingen betekent mogelijk een warmtepomp<br/>met een groter vermogen en buffervat',
      answers: {
        1: '1x',
        2: '2x',
        3: '>2',
      },
    },
    shower: {
      question: 'Welk type douche is er?',
      answers: {
        6: 'Zeer besparende douchekop (4&nbsp;-&nbsp;6&nbsp;ltr&nbsp;/&nbsp;min)',
        10: 'Besparende douchekop (7&nbsp;-&nbsp;10&nbsp;ltr&nbsp;/&nbsp;min)',
        13: 'Gewone douchekop (11&nbsp;-&nbsp;13&nbsp;ltr&nbsp;/&nbsp;min)',
        17: 'Grote douchekop (14&nbsp;-&nbsp;17&nbsp;ltr&nbsp;/&nbsp;min)',
        20: 'Stortdouche (18&nbsp;-&nbsp;20&nbsp;ltr&nbsp;/&nbsp;min)',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./js/lang/nl/advisory.js